skrilla.service('contestsService', function(cacheService, modalService){

    var openRostersCalculatorModal = function(callback){
        modalService.openModal('/views/maximumEntriesPerUserCalculator/maximumEntriesPerUserCalculator.html',true, 'lg', true, true, callback);
    }

    var openSplitsModal = function (callback) {
        modalService.openModal('/views/splits/splits.html', true, 'lg', true, true, callback);
    }

    var getLocalWinAmount = function(preConvertedAmount, currency, contest){
        if(currency === contest.currency){
            return preConvertedAmount;
        }
        return preConvertedAmount * contest.exchangeRates[currency];
    }

    return {
        openSplitsModal: openSplitsModal,
        openRostersCalculatorModal: openRostersCalculatorModal,
        getLocalWinAmount: getLocalWinAmount
    };
});

